'use strict';
import moment from 'moment-timezone';
angular.module('docketbook').
  controller('filingDesktopController', function(docketService, userService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation, $q) {
    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentOrg = accessControl.currentOrg();

    $state.go('main.groupDockets',{orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, viewMode: 'filing'});


    $scope.filingsChildControllerReady = function() {
    }

    $scope.filingDetailControllerReady = function() {
    }
});



// WEBPACK FOOTER //
// ./src/controllers/filing/desktopController.js